export const DEFAULT_AI_MODEL = 'openai/gpt-5.6-terra';
